import styled from 'styled-components';
import { useState } from 'react';
import { ItemImage, SkupremeModal } from '../../components';
import { HoverBorderButton, MuteText, StyledButton } from '../../elements';

import { CommonUtility, DateUtility, ItemService, ToastMessage } from '../../utility';

const LotsContainer = styled.div`
  max-height: 25vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;

const ProductTitle = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
  display: block;
`;

export function ExportItemLogs({ open, onClose, item, warehouseId }) {
  const [loading, setLoading] = useState(false);
  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(null);

  // const onChange = dates => {
  //   const [start, end] = dates;
  //   setStartDate(DateUtility.formatDate(start, DateFormat.yearMonthDate));
  //   setEndDate(DateUtility.formatDate(end, DateFormat.yearMonthDate));
  // };

  const onConfrim = async () => {
    try {
      setLoading(true);
      const params = {
        warehouseId,
        itemId: item?.productId,
        // startDate,
        // endDate,
      };
      const res = await ItemService.exportItemLogs(item?.productId, params);
      const fileName = `${item?.product?.p_sku} - ${DateUtility.formatDate(new Date())}`;
      CommonUtility.downloadCSV(res, fileName);
      ToastMessage.success('Item logs exported successfully');
      onClose();
    } catch (error) {
      ToastMessage.apiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SkupremeModal title="Export Item Logs" open={open} onClose={onClose} size="mini">
      <div className="d-flex">
        <ItemImage
          item={item?.product}
          displayImageKey="display_image"
          imageKey="p_images"
          size="mini"
        />
        <div className="ml-2">
          <ProductTitle>{item?.product?.p_title}</ProductTitle>
          <div className="d-flex">
            <MuteText>SKU</MuteText>
            <span className="ml-2">{item?.product?.p_sku}</span>
          </div>
        </div>
      </div>
      {/* <MuteText>Logs Date</MuteText>
      <DatepickerContainer>
        <DatePicker
          className="w-100"
          formatWeekDay={nameOfDay => nameOfDay.substring(0, 3)}
          startDate={startDate ? new Date(startDate) : null}
          endDate={endDate ? new Date(endDate) : null}
          onChange={onChange}
          placeholderText="Select Date"
          customInput={
            <CalenderInput
              className="similar-height"
              icon={<Calendar className="icon" size={26} />}
            />
          }
          dateFormat={DateFormat.datepicker}
          disabledKeyboardNavigation
          maxDate={new Date()}
          selectsRange
        />
      </DatepickerContainer> */}
      <div className="my-2 pb-2">
        <MuteText>Lots</MuteText>
        <LotsContainer>
          {item?.locationSummary?.map(lot => (
            <div>{lot.lotNumber}</div>
          ))}
        </LotsContainer>
      </div>
      <div className="d-flex justify-content-end">
        <HoverBorderButton disabled={loading} onClick={onClose} className="mr-2">
          Cancel
        </HoverBorderButton>
        <StyledButton loading={loading} onClick={onConfrim}>
          Confirm
        </StyledButton>
      </div>
    </SkupremeModal>
  );
}
